import PropTypes from "prop-types";
// Helpers
import { supportedSystemPositions } from "@/Common/helpers/Positions";
// Washout contents
import SalesAssociateWashoutContent from "@/Washouts/views/Layers/Sales/Associates/SalesAssociateWashoutContent";
import FinanceManagerWashoutContent from "@/Washouts/views/Layers/Finance/Managers/FinanceManagerWashoutContent";
import SalesManagerWashoutContent from "@/Washouts/views/Layers/Sales/Managers/SalesManagerWashoutContent";
import DepartmentalWashoutContent from "@/Washouts/views/Layers/Departmental/DepartmentalWashoutContent";
import TechniciansWashoutContent from "@/Washouts/views/Layers/Technicians/TechniciansWashoutContent";
import AdvisorsWashoutContent from "@/Washouts/views/Layers/Advisors/AdvisorWashoutContent";

const POSITIONS = supportedSystemPositions();

const ContentsMap = {
	[POSITIONS.SALES.SALES_ASSOCIATE]: SalesAssociateWashoutContent,
	[POSITIONS.FINANCE.FINANCE_MANAGER]: FinanceManagerWashoutContent,
	[POSITIONS.SALES.SALES_MANAGER]: SalesManagerWashoutContent,
	[POSITIONS.SALES.GENERAL_SALES_MANAGER]: SalesManagerWashoutContent,
	[POSITIONS.FINANCE.FINANCE_DIRECTOR]: FinanceManagerWashoutContent,
	[POSITIONS.BODY_SHOP.BODY_SHOP_MANAGER]: DepartmentalWashoutContent,
	[POSITIONS.BODY_SHOP.BODY_SHOP_PRODUCT_MANAGER]: DepartmentalWashoutContent,
	[POSITIONS.BODY_SHOP.BODY_SHOP_FOREMAN]: DepartmentalWashoutContent,
	[POSITIONS.SERVICE.SERVICE_MANAGER]: DepartmentalWashoutContent,
	[POSITIONS.SERVICE.SERVICE_DIRECTOR]: DepartmentalWashoutContent,
	[POSITIONS.PARTS.PARTS_MANAGER]: DepartmentalWashoutContent,
	[POSITIONS.SERVICE.SERVICE_FOREMAN]: DepartmentalWashoutContent,
	[POSITIONS.PARTS.PARTS_DIRECTOR]: DepartmentalWashoutContent,
	[POSITIONS.SERVICE.SERVICE_TECHNICIAN]: TechniciansWashoutContent,
	[POSITIONS.BODY_SHOP.BODY_SHOP_TECHNICIAN]: TechniciansWashoutContent,
	[POSITIONS.BODY_SHOP.BODY_SHOP_PAINTER]: TechniciansWashoutContent,
	[POSITIONS.SERVICE.SERVICE_ADVISOR]: AdvisorsWashoutContent,
	[POSITIONS.SERVICE.INTERNAL_SERVICE_ADVISOR]: AdvisorsWashoutContent,
	[POSITIONS.BODY_SHOP.BODY_SHOP_ESTIMATOR]: AdvisorsWashoutContent,
};

export default function RenderWashoutInformation(props) {
	const { position = "", positionType = "", properties = null } = props;
	const isDepartmental = positionType === "Departmental";

	if (isDepartmental && position === POSITIONS.FINANCE.FINANCE_DIRECTOR) {
		return <SalesManagerWashoutContent {...properties} position={position} />;
	}

	if (isDepartmental && position === POSITIONS.PARTS.PARTS_COUNTER_ASSOCIATE) {
		return <DepartmentalWashoutContent {...properties} position={position} />;
	}

	const Content = ContentsMap?.[position] || null;
	if (Content) {
		return <Content {...properties} position={position} />;
	}

	return <></>;
}
RenderWashoutInformation.propTypes = {
	position: PropTypes.string,
	positionType: PropTypes.string,
	properties: PropTypes.object,
};
